export default __webpack_public_path__ + "static/media/SmileyFlip.a27c3f52.svg";